import { NotificationType } from "../Enums/NotificationType";

export interface INotification {
    id: number;
    /**
     * GB:
     *
     * A string because some links will be strings. It would be impossible to make this a number
     * and make it work for all use cases.
     */
    linkId: string;
    notificationType: NotificationType;
    title: string;
    description: string;
    createdDate: Date;
    modifiedDate: Date;
    isRead: boolean;
    isActive: boolean;
}

export class Notification implements INotification {
    public id = 0;
    public linkId = "";
    public notificationType: NotificationType = null;
    public title = "";
    public description = "";
    public createdDate: Date = new Date();
    public modifiedDate: Date = new Date();
    public isRead = false;
    public isActive = true;
}